import { http } from '@pendo/http';

export function get (url, options = {}) {
    return http.get(url, { withCredentials: false, ...options }).then((response) => response.data);
}

export function post (url, file, data) {
    const fd = new FormData();
    // eslint-disable-next-line guard-for-in
    for (const key in data) {
        fd.append(key, data[key]);
    }
    fd.append('file', file); // must be the last entry

    return http.post(url, fd, { withCredentials: false, headers: { 'Content-Type': 'multipart/form-data' } });
}
